export enum PollStatus {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
  RESET = 'reset',
  STOP = 'stop'
}

export function poll(
  promiseFn: any,
  dataFormatter: undefined | ((data: any) => { data: any }),
  pollingInterval: number,
  callback: (status: PollStatus, data?: any) => void
) {
  let killed = false;
  let timeoutId: any;
  let iterationCount = 0;

  const unsubscribe = (broadcast = false) => {
    iterationCount = 0;
    if (broadcast) {
      callback(PollStatus.STOP);
    }
    killed = true;
    clearTimeout(timeoutId);
  };

  const execute = async () => {
    try {
      clearTimeout(timeoutId);

      if (killed) return;

      callback(PollStatus.LOADING, undefined);
      let response = await promiseFn();
      if (typeof dataFormatter === 'function') {
        response = dataFormatter(response);
      }
      callback(PollStatus.SUCCESS, response);
    } catch (ex) {
      callback(PollStatus.ERROR, ex);
    }
    iterationCount++;

    timeoutId = setTimeout(execute, pollingInterval);
  };

  execute();

  return () => unsubscribe();
}
